import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useGetCurrentTenantQuery } from '../api/tenant';
import { useGetUserQuery } from '../api/user';
import { updateAccountStatus } from '../Store/accountStatusSlice';
import { RootState } from '../Store/store';

export const useAccountStatus = () => {
  const dispatch = useDispatch();
  const { data: tenantData, isLoading: tenantLoading } = useGetCurrentTenantQuery(undefined);
  const { data: userData, isLoading: userLoading } = useGetUserQuery(undefined);
  
  const accountStatus = useSelector((state: RootState) => state.accountStatus);

  useEffect(() => {
    if (!tenantLoading && !userLoading && tenantData && userData) {
      const uploadInitialAmount = tenantData.credits?.upload?.[0]?.initial_amount || 0;
      const analyzeInitialAmount = tenantData.credits?.analyze?.[0]?.initial_amount || 0;
      const storageQuota = userData.storageUsage?.quota || 0;

      dispatch(updateAccountStatus({
        uploadInitialAmount,
        analyzeInitialAmount,
        storageQuota: parseInt(storageQuota.toString()),
      }));
    }
  }, [dispatch, tenantData, userData, tenantLoading, userLoading]);

  return {
    ...accountStatus,
    isLoading: tenantLoading || userLoading,
  };
};
